import http from '@/communication/AuthConnection'

export default async () => {
  try {
    const result = await http.get(`/v1/ping`)
    return result.data.success
  } catch (e) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/view/login/brain/PingToken.js